import { render, staticRenderFns } from "./SkillEdit.vue?vue&type=template&id=9078e2ba"
import script from "../../controllers/skill/skill-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/skill/skill-edit.js?vue&type=script&lang=js&external"
import style0 from "./SkillEdit.vue?vue&type=style&index=0&id=9078e2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports